import { MODULE_NAME } from "../moduleName";
import { PagedResponse, QueryParams, UserAuth } from "@ofqual/portal-core/core/types";
import { Organisation } from "../domain/Organisation";
import { CrudResult } from "./types";
import { RecognitionApplication } from "../domain/RecognitionApplication";
import { ScopeApplicationSummary } from "../domain/ScopeApplication";
import { Scope } from "@ofqual/portal-organisations-scope/dist/module/domain/Scope";
import { LookupTrackerStore } from "@ofqual/portal-core/core/types";
import { ShareRecord } from "../domain/ShareRecord";

export type OrganisationListState = {
  response: PagedResponse<Organisation>;
  status: "NOT_LOADED" | "LOADING" | "LOADED";
  hasData: boolean;
};

export type OrganisationState = {
  org: Organisation | null;
  share: ShareRecord | null;
  status: "NOT_LOADED" | "LOADING" | "LOADED" | "UPDATING";
  lastCrudResult: CrudResult;
};

export type OrganisationScopesState = {
  scopes: Scope[] | null;
  searchParams: QueryParams;
  status: "NOT_LOADED" | "LOADING" | "LOADED";
};

export type NonNullableOrganisationState = OrganisationState & {
  org: NonNullable<OrganisationState["org"]>;
};

export type RecognitionApplicationState = {
  application: RecognitionApplication | null;
  status: "NOT_LOADED" | "LOADING" | "LOADED" | "UPDATING";
  lastCrudResult: CrudResult;
};

export type RecognitionApplicationScopesState = {
  scopes: Scope[];
  lookupTrackerStore: LookupTrackerStore;
  status: "NOT_LOADED" | "LOADING" | "LOADED" | "UPDATING";
  lastCrudResult: CrudResult;
};

export type NonNullableRecognitionApplicationState = RecognitionApplicationState & {
  application: NonNullable<RecognitionApplicationState["application"]>;
};

export type ExpansionApplicationListState = {
  response: PagedResponse<ScopeApplicationSummary>;
  status: "NOT_LOADED" | "LOADING" | "LOADED";
  hasData: boolean;
  itemId: string | null;
};
interface ModuleState {
  organisationList: OrganisationListState;
  organisation: OrganisationState;
  application: RecognitionApplicationState;
  applicationScopes: RecognitionApplicationScopesState;
  expansionApplicationList: ExpansionApplicationListState;
  organisationScopes: OrganisationScopesState;
}

export enum UserType {
  Unknown = 0,
  Ofqual = 1,
  CCEA = 2,
  AO = 3,
  Magic = 4
}

// if there is any state from other modules that we use in this module
//  we have an opportunity to at least type it for ourselves.
// If nothing else, store.auth will be needed to get to get the api token
interface RemoteState {
  auth: {
    user: UserAuth
  };
}

export interface GlobalState extends RemoteState {
  [MODULE_NAME]: ModuleState;
}
